import React from "react"
import {
  Card,
} from 'AtomicComponents'
import urlHandler from 'AtomicUtils/urlHandler'
import dateHandler from 'AtomicUtils/dateHandler'

class ArticlePreview extends React.Component {
  render() {
    const {
      title,
      imageUrl,
      articleDate,
      preHeading,
      categories,
      articleUrl,
      featured = false,
      gtm
    } = this.props

    return (
      <Card
        heading={title}
        imageSrc={imageUrl}
        note={new dateHandler(articleDate).format('0D/0M/YYYY')}
        preHeading={preHeading || (categories && categories.length && categories[0])}
        onClick={() => { new urlHandler(articleUrl).redirect()}}
        linkText={'Read more'}
        featured={featured}
        gtm={gtm}
      />
    )
  }
}

export default ArticlePreview



// WEBPACK FOOTER //
// ./src/AtomicContainers/ArticlePreview/ArticlePreview.jsx